export const ENCRIPTION_KEY = process.env.REACT_APP_ENCRPYTION_KEY
export const ENCRIPTION_KEY_2 = process.env.REACT_APP_ENCRPYTION_KEY_2

export const URL_API = process.env.REACT_APP_DEBUG === "true" ? process.env.REACT_APP_URL_API_LOCAL : process.env.REACT_APP_URL_API_PRODUCTION
export const WS_API = process.env.REACT_APP_WS_API_PRODUCTION

export const URL_CABRISK = process.env.REACT_APP_URL_CABRISK_KYC;